import PromoSlots from "./components/PromoSlots";

export default PromoSlots;
